import React from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { constants } from '../../config';
import { MenuStore } from '../../stores/MenuStore';
import { ScreenStore } from '../../stores/ScreenStore';
import { SessionStore } from '../../stores/SessionStore';
import { AppLink, routeNaming, goToPage } from '../../routes';
import { NavbarSearch } from './navbar-search';
import { MenuItem } from './menu-item';
import { MenuDropdown } from '../menu-dropdown';
import { MenuOverlay } from './menu-overlay';
import { CartButton } from './cart-button';
import { USER_TYPES } from '../../models/User';
import cgLogo from '../../assets/images/cg-logo.svg';
import iconUser from './icon-user.svg';
import iconMenu from './menu.svg';
import iconClose from './close.svg';
import styles from './HomeNavbar.css';

const closeSession = () => {
  SessionStore.logout();
  window.location.href = '/';
};

const menuItems = () => {
  const items = [{ name: 'Mis datos', type: 'route', action: routeNaming.MY_DATA },
    { name: 'Mis direcciones', type: 'route', action: routeNaming.MY_ADDRESSES },
    { name: 'Mis teléfonos', type: 'route', action: routeNaming.MY_PHONE_NUMBERS },
    { name: 'Mis datos de facturación', type: 'route', action: routeNaming.MY_BILLING_DATA },
    { name: 'Mis compras', type: 'route', action: routeNaming.MY_ORDERS },
    { name: 'Mis favoritos', type: 'route', action: routeNaming.MY_FAVORITES },
  ];
  if (SessionStore.user && SessionStore.user.showCredit) {
    items.push({ name: 'Mis créditos', type: 'route', action: routeNaming.MY_CREDITS });
  }
  items.push({ name: 'Cerrar sesión', type: 'function', action: closeSession });
  return items;
};

const HomeNavbar = class HomeNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMenu: null,
      // NOTE: this only makes sense on mobile
      searchOpen: false,
      openMenuOverlay: false,
      isSidebarOpen: false,
    };
    this._closeMenu = this._closeMenu.bind(this);
    this._compressSearch = this._compressSearch.bind(this);
    this._expandSearch = this._expandSearch.bind(this);
    this._toggleMenu = this._toggleMenu.bind(this);
    this._toggleMenuMobile = this._toggleMenuMobile.bind(this);
    this._updateOpenMenu = this._updateOpenMenu.bind(this);
    this._toggleSidebar = this._toggleSidebar.bind(this);
    this._navigate = this._navigate.bind(this);
    this._navigateTo = this._navigateTo.bind(this);
  }

  /*
    This is done to close menu overlay when clicking
    an AppLink inside it, like a category or subcategory.
  */
  componentDidUpdate(prevProps, prevState) {
    // NOTE: Check if the state changed. This is a SHALLOW comparison.
    const stateChanged = Object.keys(this.state).reduce((acc, key) => (
      acc || prevState[key] !== this.state[key]
    ), false);
    // If the state has changed, then we don't need to close the modal.
    if (stateChanged) {
      return;
    }
    // If the state hasn't changed, then the route was updated.
    // NOTE: we're not checking for changes in location since the modal should
    // close even if the current location is the same one that the user has selected.
    if (this.state.openMenuOverlay) {
      this._closeMenu();
    }
  }

  _expandSearch() {
    this.setState({
      searchOpen: true,
    });
  }

  _compressSearch() {
    this.setState({
      searchOpen: false,
    });
  }

  _updateOpenMenu(menuId) {
    this.setState({
      selectedMenu: menuId,
    });
  }

  _toggleMenu() {
    this.setState(prevState => (
      {
        openMenuOverlay: !prevState.openMenuOverlay,
      }
    ));
  }

  _toggleMenuMobile(menuId) {
    this.setState(prevState => (
      {
        openMenuOverlay: !prevState.openMenuOverlay || prevState.selectedMenu !== menuId,
        selectedMenu: menuId,
      }
    ));
  }

  _closeMenu() {
    this.setState({
      selectedMenu: null,
      openMenuOverlay: false,
    });
  }

  _toggleSidebar(value) {
    this.setState({ isSidebarOpen: value });
  }

  _navigate(route, pathParam, queryParam) {
    this._toggleSidebar(false);
    goToPage(route, { subMenuId: pathParam }, queryParam ? { pt: queryParam } : {});
  }

  _navigateTo(route) {
    window.location.href = route;
  }

  _renderMenus(menus, forMobile = false) {
    return menus.map(menu => (
      <MenuItem
        className={styles.menu}
        key={menu.id}
        menu={menu}
        onClick={forMobile ? this._toggleMenuMobile : this._toggleMenu}
        onFocus={forMobile ? () => { } : this._updateOpenMenu}
        onMouseEnter={forMobile ? () => { } : this._updateOpenMenu}
        selected={menu.id === this.state.selectedMenu}
      />
    ));
  }

  render() {
    const overlayOpen = this.state.openMenuOverlay;
    const openClass = overlayOpen ? styles.overlayOpen : '';
    const openSidebarClass = this.state.isSidebarOpen ? styles.sidebar_active : '';
    const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.smallMaxWidth;
    const compressedClass = this.state.searchOpen ? styles.compressed : '';
    let menuSection = null;
    if (MenuStore.menus) {
      menuSection = this._renderMenus(MenuStore.menus, mobileVersion);
    }
    return (
      <nav className={[styles.container, openClass].join(' ')}>
        <div className={[styles.sidebar, openSidebarClass].join(' ')}>
          <div className={styles.sidebar_closeContainer} onClick={() => this._toggleSidebar(false)}>
            <img src={iconClose} alt="" className={styles.userIcon} />
          </div>
          {
            MenuStore.menus && MenuStore.menus.map(category => (
              <div key={category.id}>
                <div className={styles.sidebar_menu_item_l1}>
                  <span>{category.name}</span>
                </div>
                <ul className={styles.submenu_l1}>
                  {category.subMenus.map(submenu => (
                    <li key={submenu.id} className={styles.submenu_li}>
                      <div>
                        <div
                          onClick={() => this._navigate(routeNaming.PRODUCT_INDEX, submenu.id)}
                          className={styles.subMenuName}
                        >
                          {submenu.name}
                        </div>
                      </div>
                      <ul className={styles.submenu_l2}>
                        {submenu.productTypes.map(product => (
                          <li key={product.id} className={styles.submenu_li}>
                            <div
                              onClick={() =>
                                this._navigate(routeNaming.PRODUCT_INDEX, submenu.id, product.id)}
                              className={styles.subMenuProductName}
                            >
                              {product.name}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              </div>
            ))
          }
        </div>
        <div
          className={styles.navbarContainer}
          role="presentation"
          onFocus={this._closeMenu}
          onMouseOver={this._closeMenu}
        >
          <div className={styles.navbar}>
            {
              !mobileVersion &&
              <div className={styles.leftContainer}>
                <AppLink
                  className={styles.logoLink}
                  routeName={routeNaming.HOME}
                >
                  <img
                    alt=""
                    src={cgLogo}
                  />
                </AppLink>
                {menuSection}
              </div>
            }
            {
              !mobileVersion &&
              <div className={styles.rightContainer}>
                <NavbarSearch className={styles.search} />
              </div>
            }
            <div className={styles.userContainer}>
              {
                !mobileVersion && SessionStore.loggedIn ?
                  <MenuDropdown menu={menuItems()}>
                    <img src={iconUser} alt="" className={styles.userIcon} />
                    <div>
                      <p className={styles.userName}><span>Hola, </span>
                        {SessionStore.user.type === USER_TYPES.COMPANY ?
                          SessionStore.user.fictitiousName :
                          SessionStore.user.names}
                      </p>
                      <p className={styles.myAccount}>Mi cuenta</p>
                    </div>
                  </MenuDropdown> :
                  !mobileVersion &&
                  <AppLink
                    className={styles.userLink}
                    routeName={SessionStore.loggedIn ? routeNaming.MY_ACCOUNT : routeNaming.LOGIN}
                  >
                    <img src={iconUser} alt="" className={styles.userIcon} />
                    <div>
                      <p className={styles.myAccount}>Ingresar</p>
                    </div>
                  </AppLink>
                }
            </div>
            {
              !mobileVersion &&
              <div>
                <CartButton
                  className={styles.cartIcon}
                />
              </div>
            }
            {
              mobileVersion &&
              <div className={styles.topNavbar}>
                <div className={[styles.logoContainer, compressedClass].join(' ')}>
                  <AppLink
                    className={styles.logoLink}
                    routeName={routeNaming.HOME}
                  >
                    <img
                      alt=""
                      src={cgLogo}
                    />
                  </AppLink>
                </div>
                <div
                  className={[styles.userContainer, compressedClass].join(' ')}
                  onClick={() => this._toggleSidebar(true)}
                >
                  <img src={iconMenu} alt="" className={styles.userIcon} />
                </div>
                <NavbarSearch
                  className={styles.search}
                  compressed={!this.state.searchOpen}
                  focus
                  onCloseClick={this._compressSearch}
                  onSearchClick={this._expandSearch}
                />
                <div className={[styles.userContainer, compressedClass].join(' ')}>
                  {
                    SessionStore.loggedIn ?
                      <MenuDropdown menu={menuItems()}>
                        <img src={iconUser} alt="" className={styles.userIcon} />
                      </MenuDropdown> :
                      <AppLink
                        className={styles.userLink}
                        routeName={routeNaming.LOGIN}
                      >
                        <img src={iconUser} alt="" className={styles.userIcon} />
                      </AppLink>
                  }
                </div>
                <CartButton
                  className={[styles.cartIcon, compressedClass].join(' ')}
                />
              </div>
            }
          </div>
        </div>
        {
          overlayOpen &&
          !!this.state.selectedMenu &&
          <MenuOverlay
            className={styles.overlay}
            menuId={this.state.selectedMenu}
            onBackgroundHover={this._closeMenu}
            onClose={this._closeMenu}
          />
        }
        {/* { localStorage.getItem('last_transaction_bank') &&
          <div
            onClick={() => this._navigateTo(getRouteFor(routeNaming.CHECKOUT_BANK_SUMMARY))}
            className={styles.shopnoreviewed}
          >
            <div>¡Hola! Notamos que no pudiste ver el resultado de tu última compra.</div>
            <div className={styles.seeNow}>¡Ver aquí!</div>
          </div>
        } */}
      </nav>
    );
  }
};

const WrappedHomeNavBar = withRouter(observer(HomeNavbar));

export { WrappedHomeNavBar as HomeNavbar };



// WEBPACK FOOTER //
// ./src/common/home-navbar/HomeNavbar.jsx